import { render, staticRenderFns } from "./SubAlbum.vue?vue&type=template&id=4099e8c8&"
import script from "./SubAlbum.vue?vue&type=script&lang=js&"
export * from "./SubAlbum.vue?vue&type=script&lang=js&"
import style0 from "./SubAlbum.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports